import { _ as _defineProperty } from '../defineProperty-Y-S4SptN.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var breakPoints = ['xl', 'lg', 'md', 'sm'];
var getBreakPointValues = function getBreakPointValues(options) {
  if (typeof options === 'number' || typeof options === 'string') {
    return breakPoints.reduce(function (result, key, index) {
      return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, key, index === 0 ? options : undefined));
    }, {});
  }
  return options;
};

export { breakPoints, getBreakPointValues };
//# sourceMappingURL=index.js.map
